import getUserDataSelector from 'root/src/client/logic/api/selectors/getUserDataSelector'
import userGroupsSelector from 'root/src/client/logic/auth/selectors/userGroupsSelector'

import pathOr from 'ramda/src/pathOr'
import pipe from 'ramda/src/pipe'
import gt from 'ramda/src/gt'
import length from 'ramda/src/length'
import includes from 'ramda/src/includes'
import __ from 'ramda/src/__'

export default (state) => {
	if (includes('creator', userGroupsSelector(state))) {
		return pipe(
			pathOr([], ['profile', 'extensions']),
			length,
			gt(__, 0),
		)(getUserDataSelector(state))
	}
	return undefined
}
